export const QUALITY_OPTIONS: Array<{ value: string; label: string }> = [
  { value: '', label: 'Use global default' },
  { value: '2160', label: '2160p' },
  { value: '1440', label: '1440p' },
  { value: '1080', label: '1080p' },
  { value: '720', label: '720p' },
  { value: '480', label: '480p' },
  { value: '360', label: '360p' },
];

export const RATING_OPTIONS: Array<{ value: string; label: string }> = [
  { value: '', label: 'Use global default' },
  { value: 'G', label: 'G' },
  { value: 'PG', label: 'PG' },
  { value: 'PG-13', label: 'PG-13' },
  { value: 'R', label: 'R' },
  { value: 'NC-17', label: 'NC-17' },
];
